exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table-padding-4 td {\n  padding: 4px !important; }\n\n.contents-no-wrap {\n  white-space: nowrap; }\n\n.deleted-width-10 {\n  width: 10% !important; }\n\n.remove-height {\n  height: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/deleted_shipments/deleted_shipments.scss
// module id = 990
// module chunks = 1